import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function CroStats() {
    return (
        <section className="cro-stats">
            <Container>
                <Row>
                    <Col lg={3} md={6} sm={6} xs={12} className="mb-4 mb-lg-0">
                        <div className="cro-stat-item">
                            <h3 className="stat-heading">Conversion-Focused</h3>
                            <span className="stat-text">Landing Page Optimization</span>
                        </div>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12} className="mb-4 mb-lg-0">
                        <div className="cro-stat-item">
                            <h3 className="stat-heading">Data-Driven</h3>
                            <span className="stat-text">Analytics &amp; Insights</span>
                        </div>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12} className="mb-4 mb-lg-0">
                        <div className="cro-stat-item">
                            <h3 className="stat-heading">eCommerce Focus</h3>
                            <span className="stat-text">Online Store Growth</span>
                        </div>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                        <div className="cro-stat-item">
                            <h3 className="stat-heading">Continuous Testing</h3>
                            <span className="stat-text">A/B Testing &amp; Experiments</span>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

